import script from "./ErrorMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorMessage.vue?vue&type=style&index=0&id=d609cea8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d609cea8"]])

export default __exports__